import styled from "styled-components";

type Props = {
  isShow: boolean;
  handleLogout: () => void;
};
export const SidebarHoverMenu: React.FC<Props> = ({ isShow, handleLogout }) => {
  return (
    <>
      <StyledHoverMenu $isShow={isShow}>
        <ul>
          <li onClick={handleLogout}>
            <StyledHoverMenuText>ログアウト</StyledHoverMenuText>
          </li>
        </ul>
      </StyledHoverMenu>
    </>
  );
};

const StyledHoverMenu = styled.div<{ $isShow: boolean }>`
  position: absolute;
  bottom: 90px;
  left: 20px;
  display: ${({ $isShow }) => ($isShow ? "block" : "none")};
  min-width: 240px;
  padding: 20px 28px;
  background-color: #ffffff;
  z-index: 10001;
  filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.1));
  border-radius: 8px;
  &:before {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -40px;
    border: 6px solid transparent;
    border-top: 10px solid #fff;
  }
`;

const StyledHoverMenuText = styled.p`
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledClickableBg = styled.div<{ $isShow: boolean }>`
  display: ${({ $isShow }) => ($isShow ? "block" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 10000;
`;
